/**
 * Modo claro/oscuro del sistema de diseño (@xiltrion/ui): clase `dark` en <html>, persistida.
 * Claro por defecto, siempre: no se sigue la preferencia del sistema. Oscuro solo si el usuario lo eligió.
 */
const KEY = 'pqrs.theme';
export type ThemeMode = 'light' | 'dark';

export function getThemeMode(): ThemeMode {
  try { return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch { return 'light'; }
}
export function applyTheme(mode: ThemeMode = getThemeMode()) {
  document.documentElement.classList.toggle('dark', mode === 'dark');
}
/** Avisa a quien muestra el tema (menú de usuario, «Mi perfil») que cambió en otra parte. */
export const THEME_EVENT = 'pqrs:theme';
export function setThemeMode(mode: ThemeMode) {
  try { localStorage.setItem(KEY, mode); } catch { /* private mode */ }
  applyTheme(mode);
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: mode }));
}
export function isDark() { return document.documentElement.classList.contains('dark'); }
